/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Search1Inputs */

const vi_cmspost_search1 = /** @type {(inputs: Cmspost_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm theo tiêu đề hoặc đường dẫn`)
};

/**

* @param {Cmspost_Search1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_search1 = /** @type {((inputs?: Cmspost_Search1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Search1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_search1(inputs)
});
export { cmspost_search1 as "cmsPost_search" }